// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q_z_","colBig":"styles_colBig__FRHK6","colSmall":"styles_colSmall__jcLPl"};